import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Owned } from '../base/named';
import { AndOrOperand, QueryOperator } from '../query-expression.constants';

@Metamodel.model({})
export class QueryExpression extends Owned {
    public static readonly MODEL: IModel;
    public static readonly VALUE: IAttribute;
    public static readonly VALUE2: IAttribute;

    public andOr?: AndOrOperand;
    public selected?: AndOrOperand;
    public column?: string;
    public operator?: QueryOperator;
    public group: {
        id: number;
    };

    @Metamodel.attribute({
        templatable: true,
        association: 'VALUE'
    })
    public value?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'VALUE2'
    })
    public additionalValue?: string;
}
